/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconKeyframeFilled = createSolidComponent("keyframe-filled", "IconKeyframeFilled", [
  [
    "path",
    {
      d: "M12 4a2.599 2.599 0 0 0 -2 .957l-4.355 5.24a2.847 2.847 0 0 0 -.007 3.598l4.368 5.256c.499 .6 1.225 .949 1.994 .949a2.599 2.599 0 0 0 2 -.957l4.355 -5.24a2.847 2.847 0 0 0 .007 -3.598l-4.368 -5.256a2.593 2.593 0 0 0 -1.994 -.949z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ]
]);

export { IconKeyframeFilled as default };
//# sourceMappingURL=IconKeyframeFilled.js.map
